<template>

  <t-page>

    <t-page-form card command="view"
                 :title="'Meus Relatórios Avançados'">

      <t-msg info v-if="reports.length === 0">Nesta página você encontrará seus relatórios avançados que não estão
        expirados.
      </t-msg>

      <b-table v-if="reports.length > 0" :items="reports" :fields="reportsFields">

        <template #cell(processedStartDate)="{item}">
          {{ item.logControl.createdDate | datetime }}
        </template>

        <template #cell(deadline)="{item}">
          {{ item.deadline | date }}
        </template>

        <template #cell(statusReportByPart)="{item}">

          <div v-if="item.statusReportByPart === 4">

            <b-badge variant="success">
              Processado
            </b-badge>

            <t-button small outline-danger class="ml-2"
                      @click="confirmDeleteMyReport(item.reportByPartId)">
              <i class="nav-link-icon lnr-trash"/>
            </t-button>

          </div>

          <b-badge v-else-if="item.statusReportByPart === 90"
                   variant="danger">Erro: {{ item.errorDescription }}
          </b-badge>
          <b-badge v-else-if="item.statusReportByPart === 91"
                   variant="danger">Bloqueado várias tentativas incorretas
          </b-badge>
          <b-badge v-else-if="item.statusReportByPart === 3"
                   variant="warning">Em processamento
          </b-badge>
          <b-badge v-else-if="item.statusReportByPart === 1 || item.statusReportByPart === 2"
                   variant="light">Pendente
          </b-badge>


        </template>

        <template #cell(fileName)="{item}">

          <b-link v-show="item.statusReportByPart === 4" :to="{path:'/general/my-report/'+item.reportByPartId}">
            {{ item.fileName }}
          </b-link>

          <div v-show="item.statusReportByPart !== 4">
            <div class="d-flex d-inline">
              <t-loading class="mr-4" small
                         v-if="item.statusReportByPart === 1 || item.statusReportByPart === 2 || item.statusReportByPart === 3"/>
              <span>{{ item.fileName }}</span>
            </div>
          </div>

        </template>


      </b-table>

    </t-page-form>


  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import ui from "@/assets/scripts/ui";
import http from "@/services/config/http-common";

export default {
  mixins: [pageDefaultMixin],
  name: 'MyReport',
  data() {
    return {
      path: "general/report/my-report-by-part", //Utilizar somente quando fora do padrão
      generalResource: true, //Página de recurso geral
      genKey: false, //Utilizar quando desejar gerar chave temporária
      routeName: "",
      fieldKey: "",
      pageTitle: "Meus Relatórios Avançados",
      reports: [],
      reportsFields: [
        {
          key: "descriptionPublic",
          label: "Descrição"
        },
        {
          key: "fileName",
          label: "Arquivo"
        },
        {
          key: "processedStartDate",
          label: "Data Cadastro"
        },
        {
          key: "deadline",
          label: "Data Limite"
        },
        {
          key: "statusReportByPart",
          label: "Status"
        },

      ],
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela


      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {
      this.routeName = this.$route.name
    },
    async mountedContinued() {

      await this.getReports()

      this.setIsLoadingPage(false)

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    async getReports() {

      await crudGeneral.list(this.path).then((items) => {
        this.reports = items

        if (this.$route.name === this.routeName) {
          setTimeout(async () => {
            await this.getReports()
          }, 5000)
        }


      }).catch(error => ui.generalResponseError(this,error))

    },

    confirmDeleteMyReport(reportById) {

      ui.msgConfirm(this, '', 'Deseja excluir este relatório processado antes do término do prazo normal?', async () => {

        await http.remove(this.path, reportById).then(async () => {
          await this.getReports()
        }).catch(error => ui.generalResponseError(this,error));

      }, 'Excluir')
    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },

}
</script>
